import * as React from 'react';
import { DefaultButton, Dialog, DialogFooter, DialogType, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, Stack } from '@fluentui/react';
import { useBoolean, useId } from '@fluentui/react-hooks';
import * as Services from '../../../../Services/Services';
import { IStatusMessage } from '../../../../Models/IStatusMessage';
import { IEventApi } from '../../../../Services/API/Event/IEventApi';
import { IEventItem } from '../../../../Models/Event/IEventItem';
import { EventSearchView } from './EventSearchView';
import { IEventSreachFilter } from '../../../../Models/Event/IEventSreachFilter';
import { IEventTypeApi } from '../../../../Services/API/EventType/IEventTypeApi';
import { IEventType } from '../../../../Models/EventTypes/IEventType';
import { IAgeGoup } from '../../../../Models/AgeGroups/IAgeGroup';
import { IRoom } from '../../../../Models/Rooms/IRoom';
import { IAgeGroupApi } from '../../../../Services/API/AgeGroup/IAgeGroupApi';
import { IRoomApi } from '../../../../Services/API/Room/IRoomApi';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import { isNumeric } from '../../../../Tools/Validation';
import { EventTypeEnum } from '../../../../Models/Event/EventTypeEnum';
import { getSchoolYears } from '../../../Consts';





interface IEventSearchProps {
    deafultFilter?: IEventSreachFilter;
}

const dialogStyles = { main: { maxWidth: 450 } };

export const EventSearch: React.FunctionComponent<IEventSearchProps> = (props) => {

    const [eventItemList, setEventItemList] = React.useState<IEventItem[]>([]);
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [filter, setFilter] = React.useState<IEventSreachFilter>();

    const [eventTypes, setEventTypes] = React.useState<IEventType[]>([])
    const [ageGroups, setAgeGroups] = React.useState<IAgeGoup[]>([])
    const [district, setDistrict] = React.useState<string[]>([])

    const loadData = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const ageGroupApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const groups = await ageGroupApi.getEventByFilterQuery(filter?.schoolYear, filter?.eventTypeId, filter?.district, filter?.ageGoroupId, undefined, EventTypeEnum.Lessons, true);

        if (groups.isSuccess && groups.data) {
            setStatusMessage({ message: groups.message, type: MessageBarType.success });
            setEventItemList(groups.data);
        }
        else {
            setStatusMessage({ message: groups.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const loadEventTypes = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventTypeApi = Services.ServicesProvider.GetService<IEventTypeApi>(Services.EventTypeApi);
        const eventType = await eventTypeApi.getEventTypes(true, EventTypeEnum.Lessons);

        if (eventType.isSuccess && eventType.data) {
            setStatusMessage({ message: eventType.message, type: MessageBarType.success });
            setEventTypes(eventType.data);
        }
        else {
            setStatusMessage({ message: eventType.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const loadAgeGroups = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const ageGroupApi = Services.ServicesProvider.GetService<IAgeGroupApi>(Services.AgeGroupApi);
        const groups = await ageGroupApi.getAgeGroups("");

        if (groups.isSuccess && groups.data) {
            setStatusMessage({ message: groups.message, type: MessageBarType.success });
            setAgeGroups(groups.data);
        }
        else {
            setStatusMessage({ message: groups.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const loadDisticts = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const ageGroupApi = Services.ServicesProvider.GetService<IRoomApi>(Services.RoomApi);
        const groups = await ageGroupApi.getDistrict();

        if (groups.isSuccess && groups.data) {
            setStatusMessage({ message: groups.message, type: MessageBarType.success });
            setDistrict(groups.data.filter((v)=>v!==""));
        }
        else {
            setStatusMessage({ message: groups.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const location = useLocation();
    const [params, setSearchParams] = useSearchParams();
    const years = getSchoolYears(new Date(Date.now()));

    React.useEffect(() => {
        loadDisticts();
        loadEventTypes();
        loadAgeGroups();
        if (!props.deafultFilter) {
            var eventTypeId = params.get("eventTypeId");
            var district = params.get("district");
            var schoolYear = params.get("schoolYear");
            var ageGoroupId = params.get("ageGoroupId");

            setFilter({
                ageGoroupId: isNumeric(ageGoroupId) ? Number.parseInt(ageGoroupId) : undefined,
                district: district ? district : undefined,
                eventTypeId: isNumeric(eventTypeId) ? Number.parseInt(eventTypeId) : undefined,
                schoolYear: isNumeric(schoolYear) ? Number.parseInt(schoolYear) : years[0]
            });
        }
        else {
            setFilter(props.deafultFilter);
        }
    }, []);

    React.useEffect(() => {

        filter && loadData();
    }, [filter])

    const propertyChanged = (key: string, value: any) => {
        setFilter({ ...filter, [key]: value });
    }

    return (<>
        <EventSearchView isLoading={isLoading}
            items={eventItemList}
            statusMessage={statusMessage}
            filter={filter}
            ageGroups={ageGroups}
            eventTypes={eventTypes}
            district={district}
            schoolYears={years}
            propertyChanged={propertyChanged}
            tiles={false}
         />
        {statusMessage && statusMessage.message ? <MessageBar messageBarType={statusMessage.type}>{statusMessage.message}</MessageBar> : null}        
    </>
    )
}